import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Popup from 'reactjs-popup';

const V3MobileActionSheet = ({ open, onClose, groups, currencyToggleProps }) => {
  if (!open) return null;

  const handle = (action) => () => {
    action.onClick();
    onClose();
  };

  const nonEmpty = (groups || [])
    .map((g) => (g || []).filter(Boolean))
    .filter((g) => g.length > 0);

  return (
    <Popup
      open={open}
      onClose={onClose}
      modal
      closeOnDocumentClick
      contentStyle={{
        border: 'none',
        borderRadius: '16px 16px 0 0',
        boxShadow: '0 -4px 12px rgba(0,0,0,0.1)',
        width: '100vw',
        maxWidth: '100vw',
        margin: 0,
        padding: 0,
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
      }}
      overlayStyle={{
        background: 'rgba(0,0,0,0.4)',
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'center',
      }}
    >
      <div
        data-testid="v3-mobile-action-sheet"
        className="v3-mobile-action-sheet"
        role="menu"
      >
        {nonEmpty.map((group, gIdx) => (
          <Fragment key={`group-${gIdx}`}>
            {gIdx > 0 && <div className="v3-mobile-action-sheet__divider" role="separator" />}
            {group.map((action) => (
              <button
                key={action.id}
                type="button"
                role="menuitem"
                data-action-id={action.id}
                className={[
                  'v3-mobile-action-sheet__row',
                  action.destructive && 'v3-mobile-action-sheet__row--destructive',
                  action.brand && 'v3-mobile-action-sheet__row--brand',
                ].filter(Boolean).join(' ')}
                onClick={handle(action)}
              >
                {action.icon && <i className={`${action.icon} v3-mobile-action-sheet__icon`} />}
                <span>{action.label}</span>
              </button>
            ))}
          </Fragment>
        ))}

        {currencyToggleProps && (
          <div
            data-testid="v3-mobile-action-sheet-currency-toggle"
            className="v3-mobile-action-sheet__currency-toggle"
          >
            <span>{currencyToggleProps.label}</span>
            <label className="v3-mobile-action-sheet__switch">
              <input
                type="checkbox"
                checked={!!currencyToggleProps.enabled}
                onChange={currencyToggleProps.onToggle}
              />
              <span className="v3-mobile-action-sheet__slider" />
            </label>
          </div>
        )}
      </div>
    </Popup>
  );
};

const actionShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  icon: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  destructive: PropTypes.bool,
  brand: PropTypes.bool,
});

V3MobileActionSheet.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  groups: PropTypes.arrayOf(PropTypes.arrayOf(actionShape)).isRequired,
  currencyToggleProps: PropTypes.shape({
    enabled: PropTypes.bool,
    onToggle: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,
    tooltip: PropTypes.string,
  }),
};

V3MobileActionSheet.defaultProps = {
  currencyToggleProps: null,
};

export default V3MobileActionSheet;
